import { useCallback, useRef } from 'react';

import * as Yup from 'yup';
import { FormHandles } from '@unform/core';

import api from 'services/api';
import { useNotices } from 'hooks';
import getValidationErrors from 'utils/getValidationErrors';

import Input from 'components/common/Input';
import Modal from 'components/common/Modal';

import * as S from './styles';

interface ISendMeEmailProps {
  setShowModalLetMeKnow(state: boolean): void;
  sku: string;
}

export function SendMeEmail({ setShowModalLetMeKnow, sku }: ISendMeEmailProps) {
  const { addNotices } = useNotices();
  const formSendMeEmail = useRef<FormHandles>(null);

  const handleLetMeKnow = useCallback(async data => {
    try {
      formSendMeEmail.current?.setErrors({});

      const schema = Yup.object().shape({
        email: Yup.string()
          .email('E-mail inválido')
          .max(100, 'Email muito extenso.')
          .required('Campo obrigatório.'),
      });

      await schema.validate(data, { abortEarly: false });

      const response = await api.post('aviseme', {
        email: data.email,
        sku,
        nome: 'Anonimo',
      });

      if (!response.data.contemAvisos && !response.data.contemErros) {
        setShowModalLetMeKnow(false);

        addNotices({
          type: 'success',
          messages: [
            'Registramos sua solicitação, assim que o produto voltar ao estoque entraremos em contato!',
          ],
        });
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formSendMeEmail.current?.setErrors(errors);
      }

      if (err?.data) {
        addNotices({ messages: [err.data.erros], type: 'errors' });
      }
    }
  }, []);

  return (
    <Modal onClose={() => setShowModalLetMeKnow(false)}>
      <S.Container
        ref={formSendMeEmail}
        className="modal-send-me-email"
        onSubmit={handleLetMeKnow}
      >
        <h4>
          Deixe seu e-mail e te avisamos quando o produto estiver de volta em
          estoque!
        </h4>

        <p>Produto sujeito a alteração de preço</p>

        <Input name="email" placeholder="Seu email" />

        <button type="submit" className="modal-button">
          Receber
        </button>
      </S.Container>
    </Modal>
  );
}
